import React, { Component } from 'react';

import classnames from 'classnames';
import FormControl from '@mui/material/FormControl';
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from '@mui/material/FormHelperText';
import TextField from "@mui/material/TextField";
import { WithStyles, withStyles } from '@mui/styles';

import APSelect from "./APSelect";

import ErrorIcon from './../APInput/assets/icon-error.svg';
import ValidIcon from './../APInput/assets/icon-tick-outline.svg';

import APSelectComboStyles from "./styles/APSelectCombo.style";
import { MASK_CLASS } from '../../../core/utils/Constants/Constants';

type ReferenceData = {
  label: string;
  value: any;
};

interface APSelectComboProps extends WithStyles<typeof APSelectComboStyles> {
  children?: any,
  className: string,
  data?: Array<ReferenceData>,
  error?: boolean,
  helperText?: string,
  onBlur?: Function,
  onChange: Function,
  onFocus?: Function,
  name?: string,
  selectComboFormikNames?: any,
  label: string,
  countryCodeLabel?: string,
  type: string,
  value?: any,
  isCoralogixMasked?: boolean
}

class APSelectComboFormik extends Component<APSelectComboProps, {}> {
  state = {
    focused: false,
    touched: false
  };

  constructor(props: APSelectComboProps) {
    super(props);

    this.onBlur = this.onBlur.bind(this);
    this.onChangeInput = this.onChangeInput.bind(this);
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  onBlur() {
    const {
      onBlur,
      name,
      value
    } = this.props;

    this.setState({
      focused: false,
      touched: true
    }, () => {
      if (onBlur) {
        onBlur({
          target: {
            name,
            value
          }
        });
      }
    });
  }

  onFocus() {
    const {
      onFocus,
      name
    } = this.props;

    this.setState({
      focused: true
    }, () => {
      if (onFocus) {
        onFocus({
          target: {
            name
          }
        });
      }
    });
  }

  onChangeInput(evt: any) {
    const { onChange, name, value } = this.props;

    if (onChange) {
      onChange({
        target: {
          name,
          value: {
            ...value,
            input: evt.target.value,
          },
        },
      });
    }
  }

  onChangeSelect(evt: any) {
    const { onChange, name, value } = this.props;

    if (onChange) {
      onChange({
        target: {
          name,
          value: {
            ...value,
            select: evt.target.value,
            displayName: evt.target.displayName
          },
        },
      });
    }
  }

  render() {
    const {
      className,
      classes,
      error,
      helperText,
      label,
      countryCodeLabel,
      type,
      value,
      onChange,
      isCoralogixMasked
    } = this.props;

    const formControlCls = classnames(className, classes.comboContainer, {
      [classes.active]: this.state.focused,
      [classes.error]: error
    });

    const selectControlCls = classnames(
      classes.formControl,
      classes.selectControl
    );
    const inputControlCls = classnames(
      classes.formControl,
      classes.inputControl
    );

    const selectValue = value && value.select !== null ? value.select?.replace("++", "+") : '';
    const inputValue = value && value.input !== null ? value.input : '';
    const displayNameValue = value && value.displayName !== undefined ? value.displayName : 'United Kingdom';

    return (
      <FormGroup className={formControlCls}>
        <APSelect
          className={selectControlCls}
          name={this.props.selectComboFormikNames ? this.props.selectComboFormikNames[0] : ''}
          onBlur={this.onBlur}
          onChange={(e) => {
            e.target.value = '+'.concat(e.target.value.replace(/\+/g, ' ').trim());
            onChange(e)
          }
          }
          onFocus={this.onFocus}
          type={type}
          value={selectValue}
          label={countryCodeLabel}
          displayName={displayNameValue}
        />
        <FormControl className={inputControlCls} variant="outlined">
          <TextField
            error={error}
            label={label}
            name={this.props.selectComboFormikNames ? this.props.selectComboFormikNames[1] : ''}
            onBlur={this.onBlur}
            onChange={(e) => {
              onChange(e)
            }}
            onFocus={this.onFocus}
            variant="outlined"
            value={inputValue}
            inputProps={{
              "data-testid": "select-comboinput",
              className: isCoralogixMasked ? MASK_CLASS : "",
            }}
          />
        </FormControl>
        {helperText && (
          <FormHelperText className={classes.helperText} error={error}>
            {helperText}
          </FormHelperText>
        )}
        {error && (
          <img className={classes.stateIcon} src={ErrorIcon} alt="Invalid input icon" />
        )}
        {this.state.touched && !error && (
          <img className={classes.stateIcon} src={ValidIcon} alt="Valid input icon" />
        )}
      </FormGroup>
    );
  }
}

export default withStyles(APSelectComboStyles)(APSelectComboFormik);
